export enum GlobalEditorialRoutes {
  BASE = 'search',
  EDITORIALS = 'editorial'
}
